<!-- Boton flotante. Siempre a la vista, con o sin sesion iniciada. -->
<button
  type="button"
  class="soporte-fab"
  [class.soporte-fab--oculto]="abierto"
  (click)="abrir()"
  aria-label="Pedir soporte"
>
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M12 2a9 9 0 0 0-9 9v5a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H5v-.06A7 7 0 0 1 19 11v.94h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1 3 3 0 0 1-3 2h-2a1 1 0 0 0 0 2h2a5 5 0 0 0 4.9-4A3 3 0 0 0 21 16v-5a9 9 0 0 0-9-9z"/>
  </svg>
  <span class="soporte-fab__texto">Soporte</span>
</button>

@if (abierto) {
  <div class="soporte-fondo" (click)="onFondoClick($event)">
    <section class="soporte-panel" role="dialog" aria-modal="true" aria-labelledby="soporte-titulo">
      <header class="soporte-panel__cabecera">
        <svg class="soporte-panel__decoracion" width="186" height="180" viewBox="0 0 186 180" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <foreignObject x="0" y="0" width="185.27" height="183.601"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(0px);clip-path:url(#bgblur_0_437_3830_clip_path);height:100%;width:100%"></div></foreignObject><g filter="url(#filter0_i_437_3830)" data-figma-bg-blur-radius="0">
            <ellipse cx="92.6348" cy="89.8004" rx="93.4522" ry="88.9065" transform="rotate(-154.266 92.6348 89.8004)" fill="url(#paint0_linear_437_3830)" fill-opacity="0.2"/>
          </g>
          <defs>
            <filter id="filter0_i_437_3830" x="0" y="0" width="185.27" height="183.601" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"/>
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow_437_3830"/>
            </filter>
            <clipPath id="bgblur_0_437_3830_clip_path" transform="translate(0 0)"><ellipse cx="92.6348" cy="89.8004" rx="93.4522" ry="88.9065" transform="rotate(-154.266 92.6348 89.8004)"/>
          </clipPath><linearGradient id="paint0_linear_437_3830" x1="-22.3833" y1="89.1004" x2="138.478" y2="139.014" gradientUnits="userSpaceOnUse">
          <stop stop-color="#AD46FF" stop-opacity="0.05"/>
          <stop offset="1" stop-color="#00B8DB" stop-opacity="0.07"/>
        </linearGradient>
        </defs>
        </svg>
        <h2 id="soporte-titulo" class="soporte-panel__titulo">
          {{ paso === 'listo' ? 'Solicitud recibida' : '¿Necesitas ayuda?' }}
        </h2>
        <button type="button" class="soporte-cerrar" (click)="cerrar()" aria-label="Cerrar">×</button>
      </header>

      <!-- Confirmacion. Se le muestra el número para que pueda citarlo. -->
      @if (paso === 'listo') {
        <div class="soporte-listo">
          <div class="soporte-listo__marca" aria-hidden="true">✓</div>
          <p class="soporte-listo__texto">
            Recibimos tu solicitud. Te contactamos al número que nos dejaste.
          </p>
          <p class="soporte-listo__numero">
            Tu número de ticket es <strong>{{ numeroDeTicket }}</strong>
          </p>
          <button type="button" class="soporte-boton" (click)="cerrar()">Listo</button>
        </div>
      } @else {
        <form class="soporte-form" (ngSubmit)="enviar()">
          <label class="soporte-campo">
            <span class="soporte-campo__etiqueta">Número de orden</span>
            <input
              type="text"
              name="orderNumber"
              [(ngModel)]="orderNumber"
              placeholder="ORD-041696"
              autocomplete="off"
              [disabled]="paso === 'enviando'"
              (blur)="marcarTocado('orderNumber')"
            />
            @if (errorOrderNumber) {
              <span class="soporte-campo__error">{{ errorOrderNumber }}</span>
            } @else {
              <span class="soporte-campo__ayuda">Está en el correo de tu compra.</span>
            }
          </label>

          <label class="soporte-campo">
            <span class="soporte-campo__etiqueta">Tu nombre</span>
            <input
              type="text"
              name="requesterName"
              [(ngModel)]="requesterName"
              placeholder="Nombre y apellido"
              autocomplete="name"
              [disabled]="paso === 'enviando'"
              (blur)="marcarTocado('requesterName')"
            />
            @if (errorNombre) {
              <span class="soporte-campo__error">{{ errorNombre }}</span>
            }
          </label>

          <label class="soporte-campo">
            <span class="soporte-campo__etiqueta">Teléfono de contacto</span>
            <input
              type="tel"
              name="requesterPhone"
              [(ngModel)]="requesterPhone"
              placeholder="+58 412 123 4567"
              autocomplete="tel"
              [disabled]="paso === 'enviando'"
              (blur)="marcarTocado('requesterPhone')"
            />
            @if (errorTelefono) {
              <span class="soporte-campo__error">{{ errorTelefono }}</span>
            } @else {
              <span class="soporte-campo__ayuda">Con el código de tu país.</span>
            }
          </label>

          <label class="soporte-campo">
            <span class="soporte-campo__etiqueta">¿Qué pasó?</span>
            <textarea
              name="description"
              rows="4"
              [(ngModel)]="description"
              placeholder="Cuéntanos con tus palabras qué necesitas."
              [disabled]="paso === 'enviando'"
              (blur)="marcarTocado('description')"
            ></textarea>
            @if (errorDescripcion) {
              <span class="soporte-campo__error">{{ errorDescripcion }}</span>
            }
          </label>

          <!-- Adjuntos: una captura explica en un segundo lo que en texto cuesta. -->
          <div class="soporte-campo">
            <span class="soporte-campo__etiqueta">
              Imágenes <span class="soporte-campo__opcional">(opcional)</span>
            </span>

            @if (previews.length) {
              <ul class="soporte-adjuntos">
                @for (preview of previews; track preview; let i = $index) {
                  <li class="soporte-adjunto">
                    <img [src]="preview" alt="" />
                    <button
                      type="button"
                      class="soporte-adjunto__quitar"
                      (click)="quitarArchivo(i)"
                      aria-label="Quitar imagen"
                    >×</button>
                  </li>
                }
              </ul>
            }

            @if (archivos.length < maximoArchivos) {
              <label class="soporte-subir">
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/jfif,image/avif,image/webp"
                  multiple
                  (change)="onArchivos($event)"
                  [disabled]="paso === 'enviando'"
                  hidden
                />
                <span>+ Adjuntar imagen</span>
              </label>
            }
          </div>

          @if (error) {
            <p class="soporte-error" role="alert">{{ error }}</p>
          }

          <button
            type="submit"
            class="soporte-boton"
            [disabled]="paso === 'enviando'"
          >
            {{ paso === 'enviando' ? 'Enviando…' : 'Enviar solicitud' }}
          </button>
        </form>
      }
    </section>
  </div>
}